function buildUrlQueryParams(url, params = []) {
  let query = new URLSearchParams(params).toString();

  if (query.length) {
    const endsQuestionMark = url[url.length - 1] === '?';
    if (!endsQuestionMark) {
      query = `?${query}`;
    }

    return `${url}${query}`;
  }

  return url;
}

export default buildUrlQueryParams;
